import {UserSettings} from 'src/openapi/models/UserSettings';
import {RootState} from 'src/store/store';

export const getUserSettings = (state: RootState): UserSettings | null => state.userSettings.data;
